import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Avatar, Text } from '@devfolioco/genesis';
import { Analytics } from '@devfolioco/helpers';
import { BASE_URL } from '@constants/environment';
import React from 'react';

import { logOut } from 'actions/authentication';
import { history } from 'helpers/history';
import { routeToOrganizerDashboard } from 'helpers';
import { isUserAdmin, isUserBeta } from 'selectors';
import { ANALYTICS_TRACKING_EVENTS } from '@constants';
import { getOrganizerHackathons, getSquadHackathons } from 'selectors/hackathon';
import { isLookingForOpportunities } from 'selectors/email';

import { SkeletonBox, SkeletonLine, Flex, SkeletonCircle } from 'components/Skeleton';
import Header from 'components/Header';
import Logo from 'components/Logo';
import { Nav, Container, AvatarMenu, StyledDropdown, Separator } from './style';

const MENU = {
  myDevfolio: 'My Devfolio',
  profile: 'Edit Profile',
  hackathons: 'Hackathons',
  projects: 'Projects',
  skills: 'Badges',
  claims: 'Claims',
  organizerDashboard: 'Organize a hackathon',
  notifications: 'Notifications',
  // shop: 'Shop',
  settings: 'Settings',
  logOut: 'Log Out',
};

export class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDropdownVisible: false,
      menu: MENU,
    };

    this.avatarMenu = React.createRef();
  }

  componentDidMount() {
    if (typeof window === 'object') {
      document.addEventListener('mousedown', this.handleClick, false);
    }
    // const { isUserBeta: isUserBetaCurrently } = this.props;

    // if (isUserBetaCurrently) {
    //   this.showShop();
    // } else {
    //   this.hideShop();
    // }
  }

  componentWillUnmount() {
    if (typeof window === 'object') {
      document.removeEventListener('mousedown', this.handleClick, false);
    }
  }

  showShop = () => {
    const { isHacker } = this.props;
    const organizerDashboard = isHacker ? 'Organize a hackathon' : 'Organizer Dashboard';

    this.setState(prevState => ({
      ...prevState,
      menu: {
        ...MENU,
        organizerDashboard,
      },
    }));
  };

  hideShop = () => {
    this.setState(prevState => {
      const { isHacker } = this.props;
      const { shop, ...rest } = prevState.menu;
      const organizerDashboard = isHacker ? 'Organize a hackathon' : 'Organizer Dashboard';

      return {
        ...prevState,
        menu: {
          ...rest,
          organizerDashboard,
        },
      };
    });
  };

  handleClick = e => {
    if (this.avatarMenu.current !== null && this.avatarMenu.current.contains(e.target)) {
      return;
    }

    this.closeDropdown();
  };

  handleNavigation = path => {
    const { isWithoutProviders } = this.props;

    if (isWithoutProviders) {
      window.location.href = `${BASE_URL}${path}`;
    } else {
      history.push(`/${path}`);
    }
  };

  handleChange = link => {
    this.closeDropdown();
    const { menu } = this.state;

    Analytics.trackEvent(ANALYTICS_TRACKING_EVENTS.DROPDOWN_MENU_CLICK, {
      item: link,
    });

    switch (link) {
      case menu.myDevfolio: {
        const { username } = this.props;
        window.location.href = `${BASE_URL}@${username}`;
        break;
      }

      case menu.profile:
        this.handleNavigation('profile');
        break;

      case menu.skills:
        this.handleNavigation('badges');
        break;

      case menu.projects:
        this.handleNavigation('projects');
        break;

      case menu.hackathons:
        this.handleNavigation('hackathons/applied');
        break;

      case menu.claims:
        window.location.href = `${BASE_URL}claims`;
        break;

      case menu.shop:
        this.handleNavigation('hackathons?shop_modal=true');
        break;

      case menu.settings:
        this.handleNavigation('settings');
        break;

      case menu.organizerDashboard: {
        routeToOrganizerDashboard();
        break;
      }

      case 'Log Out': {
        const { logOutDispatcher } = this.props;
        logOutDispatcher();
        break;
      }

      case menu.notifications: {
        window.location.href = `${BASE_URL}notifications`;
        break;
      }

      default:
        throw new Error('Navigation: Invalid link Value');
    }
  };

  toggleDropdown = () =>
    this.setState(prevState => ({
      isDropdownVisible: !prevState.isDropdownVisible,
    }));

  closeDropdown = () => this.setState({ isDropdownVisible: false });

  render() {
    const {
      profileImageURL,
      username,
      disabled,
      isAuthenticated,
      showHeader,
      hideLogo,
      transparent,
      loading,
      subtitle,
    } = this.props;
    const { isDropdownVisible, menu } = this.state;
    const dropdownLinks = Object.values(menu);

    return (
      <Nav transparent={transparent}>
        <Container hideLogo={hideLogo} transparent={transparent}>
          {!hideLogo && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {disabled ? (
                <Logo />
              ) : (
                <a href={`${BASE_URL}discover`} aria-label="Devfolio Discover">
                  <Logo style={{ marginRight: subtitle ? 15 : 32 }} />
                </a>
              )}
              {subtitle && (
                <div style={{ display: 'flex' }}>
                  <Separator />
                  <Text upgrade size={30} weight="extrabold">
                    {subtitle}
                  </Text>
                </div>
              )}
              {showHeader && <Header />}
            </div>
          )}

          {loading && (
            <SkeletonBox style={{ height: 48, width: 180 }} offwhite>
              <Flex style={{ alignItems: 'center' }}>
                <SkeletonLine height={24} width={120} />
                <SkeletonCircle radius={24} ml={16} />
              </Flex>
            </SkeletonBox>
          )}

          {!loading && (
            <>
              {isAuthenticated ? (
                <div ref={this.avatarMenu}>
                  <AvatarMenu disabled={disabled} onClick={disabled ? null : this.toggleDropdown}>
                    <Text upgrade size={16} weight="bold">
                      {username || ''}
                    </Text>
                    <Avatar src={profileImageURL} />
                  </AvatarMenu>
                  {isDropdownVisible && (
                    <StyledDropdown
                      items={dropdownLinks}
                      onChange={this.handleChange}
                      separators={[
                        dropdownLinks.indexOf(menu.hackathons),
                        dropdownLinks.indexOf(menu.organizerDashboard),
                        dropdownLinks.indexOf(menu.notifications),
                      ]}
                    />
                  )}
                </div>
              ) : (
                <a href="/signin" aria-label="Sign in to Devfolio">
                  Sign In
                </a>
              )}
            </>
          )}
        </Container>
      </Nav>
    );
  }
}

const mapStateToProps = ({ user, authentication, hackathon, email }) => ({
  isOpenToOpportunites: isLookingForOpportunities(email),
  isAuthenticated: authentication.isAuthenticated && authentication.uuid,
  hackathons: [...getOrganizerHackathons(hackathon), ...getSquadHackathons(hackathon)],
  profileImageURL: user.profileImageURL || '',
  username: authentication.username || '',
  isHacker: !isUserAdmin(user),
  publicProfileVisible: user.publicProfileVisible,
  isUserBeta: isUserBeta(user),
});

const mapDispatchToProps = dispatch => ({
  logOutDispatcher: async () => {
    Analytics.resetAnalytics();

    await dispatch(logOut(true, '/'));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navigation));
